module.exports = __webpack_public_path__ + "img/user.6308a452.svg";